module.exports = __webpack_public_path__ + "static/media/refresh-icon.edd23107.svg";